import createAction from '../../../../util/createAction';

export const CHOOSE_TERM = 'addon/term/CHOOSE';

export const chooseTerm = createAction(CHOOSE_TERM);
